const UserAddress = ({
  street = '',
  city = '',
  state = '',
  zip = '',
  country = '',
  unit = '',
  addressLine = '',
}: {
  street: string;
  city: string;
  state: string;
  zip: string;
  country?: string;
  unit?: string;
  addressLine?: string;
}) => ({
  street: String(street),
  city: String(city),
  state: String(state),
  zip: String(zip),
  country: String(country),
  unit: String(unit),
  addressLine: String(addressLine),
});

export default UserAddress;

export type UserAddressProps = ReturnType<typeof UserAddress>;
